import Litepicker from 'litepicker';

function zeroPad(num, places) {
    var zero = places - num.toString().length + 1;
    return Array(+(zero > 0 && zero)).join("0") + num;
}

$(function () {

    if ($(".js_open_booking_strip")[0]) {
        $("header:not(.open) .js_open_booking_strip").on("click", function () {
            if (!$("header").hasClass("open")) {
                $("header").addClass("open");
            }
        })

        var moment = require('moment');

        let format = 'YYYY-MM-DD'; //<-- Change this to the date format your using for your project, otherwise this doesn't matter keep it the same.
        let today = moment(); //Gets today's date in a moment object
        today.subtract(1, 'days').format(format); //Subtract a day, then format to whatever your 'lockDaysFormat' string is.
        const disallowedDates = [['2001-01-01', today]]//Make a 2D array with those those variables.


        const picker = new Litepicker({
            element: document.getElementById('datepickr'),
            singleMode: false,
            numberOfMonths: 2,
            numberOfColumns: 2,
            switchingMonths: 1,
            mobileFriendly: true,
            lockDaysFormat: format,
            autoApply: true,
            lockDays: disallowedDates,
            buttonText: { "apply": "Toepassen", "cancel": "Datum wissen" },
            tooltipText: {
                one: 'night',
                other: 'nights'
            },
            tooltipNumber: (totalDays) => {
                return totalDays - 1;
            }
        });

        if ($(".date_container")[0]) {
            $(".date_container").on('click', function () {
                picker.show();
                $("#checkin_container").addClass("active");
            })

            var selected = false;


            picker.on('before:click', (target) => {
                if ($(target).attr('type') != "button") {

                    selected = true;
                    var d = moment($(target).data("time"));

                    if (!$(target).hasClass("is-end-date")) {
                        $("#checkin_container").removeClass("active");
                        $("#checkin_container .value").html(d.format('DD MMM'))
                        $("#checkout_container").addClass("active");
                    } else {
                        $("#checkout_container .value").html(d.format('DD MMM'))

                    }
                }
            });

            $("#checkin_container .value").html($("#checkin").val())
            $("#checkout_container .value").html($("#checkout").val())

            if (!$(".homepage")[0]) {
                picker.on('selected', (date1, date2) => {
                    if (selected) {
                        $("#checkin").val(date1.getFullYear() + "-" + (zeroPad(date1.getMonth() + 1, 2)) + "-" + (zeroPad(date1.getDate(), 2)))
                        $("#checkout").val(date2.getFullYear() + "-" + (zeroPad(date2.getMonth() + 1, 2)) + "-" + (zeroPad(date2.getDate(), 2)))
                        $("#checkinvalue").html($("#checkin").val())
                        $("#checkoutvalue").html($("#checkout").val())

                        const urlParams = new URLSearchParams(window.location.search);
                        urlParams.set("checkin", date1.getFullYear() + (zeroPad(date1.getMonth() + 1, 2)) + (zeroPad(date1.getDate(), 2)));
                        urlParams.set("checkout", date2.getFullYear() + (zeroPad(date2.getMonth() + 1, 2)) + (zeroPad(date2.getDate(), 2)));

                        window.location.search = urlParams;
                    }
                });
            }

            picker.on('hide', () => {
                $(".date_container").removeClass("active")
            });
        }

        let searchParams = new URLSearchParams(window.location.search)

        if (searchParams.has('checkin')) {
            picker.setDate(moment(searchParams.get('checkin'), 'YYYYMMDD').toDate())
        }
        else if (searchParams.has('checkout')) {
            picker.setDate(moment(searchParams.get('checkout'), 'YYYYMMDD').toDate())
        }

        if (searchParams.has('checkin') && searchParams.has('checkout')) {
            if (moment(searchParams.get('checkin'), 'YYYYMMDD').toDate() < moment(searchParams.get('checkout'), 'YYYYMMDD').toDate()) {
                picker.setDateRange(moment(searchParams.get('checkin'), 'YYYYMMDD').toDate(), moment(searchParams.get('checkout'), 'YYYYMMDD').toDate())
            } else {

                picker.setDateRange(moment(searchParams.get('checkout'), 'YYYYMMDD').toDate(), moment(searchParams.get('checkin'), 'YYYYMMDD').toDate())
            }
        }

        $(".js_dropdown_toggle").on("click", function () {
            $("#" + $(this).data("target")).toggleClass("active")
        })

        $(".js_input_min").on("click", function () {
            if ($(this).parent().find("input").val() != 0) {
                $(this).parent().find("input").val($(this).parent().find("input").val() - 1);
                var adults = $("#NumtempAdult").val();
                var children = $("#NumtempChildren").val();
                $("#numguests").html(parseInt(adults) + parseInt(children) + " Guests");
            }
        })
        $(".js_input_plus").on("click", function () {
            $(this).parent().find("input").val(parseInt($(this).parent().find("input").val()) + 1);
            var adults = $("#NumtempAdult").val();
            var children = $("#NumtempChildren").val();
            $("#numguests").html(parseInt(adults) + parseInt(children) + " Guests");
        })

        $(".js_apply_guests").on("click", function () {
            var adults = $("#NumtempAdult").val();
            var children = $("#NumtempChildren").val();

            const urlParams = new URLSearchParams(window.location.search);
            urlParams.set("guests", parseInt(adults) + parseInt(children));
            urlParams.set("numAdult", parseInt(adults));
            urlParams.set("numChildren", parseInt(children));

            window.location.search = urlParams;
        })

        $("body").on("click", function (e) {
            if ($('.dropdown').find(e.target).length != 1) {
                if (!$(e.target).hasClass("dropdown") && !$(e.target).hasClass("js_dropdown_toggle")) {
                    $(".dropdown").removeClass("active");
                }
            }
        })

        if (searchParams.has('numAdult')) {
            $("#NumtempAdult").val(searchParams.get('numAdult'))
        }
        if (searchParams.has('numChildren')) {
            $("#NumtempChildren").val(searchParams.get('numChildren'))
        }
        if (searchParams.has('guests')) {
            $("#numguests").html(searchParams.get('guests') + " Guests")
        }

        $(".js_submit_home_search").on("click", function () {
            var adults = parseInt($("#NumtempAdult").val());
            var children = parseInt($("#NumtempChildren").val());

            var guests = adults + children;
            var location = ""

            if ($("#locationbookingstrip")[0]) {
                location = "&location=" +$("#locationbookingstrip").val();
            }

            if (picker.getDate() && picker.getEndDate()) {

                var startDate = picker.getDate();
                startDate = startDate.getFullYear() + (zeroPad(startDate.getMonth() + 1, 2)) + (zeroPad(startDate.getDate(), 2))

                var endDate = picker.getEndDate();
                endDate = endDate.getFullYear() + (zeroPad(endDate.getMonth() + 1, 2)) + (zeroPad(endDate.getDate(), 2))

                window.location.href = $(this).data("target") + "?checkin=" + startDate + "&checkout=" + endDate + "&guests=" + guests + "&numAdults=" + adults + "&numChildren=" + children + location;
            } else {
                window.location.href = $(this).data("target") + "?showAll=True&guests=" + guests + "&numAdults=" + adults + "&numChildren=" + children + location;
            }
        })
    };

    if($(".lister .location_container")[0]) {



        $(".lister #locationbookingstrip").on("keyup", function (e) {
            $(".lister .location_container").addClass("submitVisible")
        })

        $(".lister #locationbookingstrip").on("click", function (e) {
            var posX = $(this).offset().left + $(this).width()
            if (e.pageX > (posX - 25)) {
                const urlParams = new URLSearchParams(window.location.search);
                urlParams.set("location", $(".lister #locationbookingstrip").val())
                window.location.search = urlParams;
            }
        })
    }
});
